import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { NotificationService } from 'src/app/core/services/notification.service';
declare let L;
declare let google: any;

@Component({
  selector: 'app-track-trip-map-v3',
  templateUrl: './track-trip-map-v3.component.html',
  styleUrls: ['./track-trip-map-v3.component.scss']
})
export class TrackTripMapV3Component {

  modifyshow: boolean = true;
  dialogData: any;
  lat = 13.0196;
  lng = 77.5968;
  map: any;
  ltlngs = [];
  sortedWP = [];
  dialogData1: any[] = [];
  zoneName: any;
  currentUser: any;
  tripStatus: any;
  tripsList: any[] = [];
  _mCurrentUser: any;
  liveData: any;
  markers: any[] = [];
  tripListData: any;
  routeId: any;
  roleName: any;
  showGoogleMap = false;
  isOsm = false;
  private googleMapInitialized = false;
  private mapLoadAttempts = 0;
  private readonly maxMapLoadAttempts = 30;
  private routePolyline: any = null;

  constructor(
    public serviceLocalStorage: ServiceLocalStorage,
    public dialogRef: MatDialogRef<TrackTripMapV3Component>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogData1.push(data);
    this.dialogData = data;
  }

  ngOnInit() {
    this.currentUser = this.serviceLocalStorage.getUserObject();
    this.roleName = this.currentUser.userInfoDetails.role.name;
    this.zoneName = this.data.data.zone == null ? 'NA' : this.data.data.zone.name;
    this.tripsList.push(this.dialogData.data.tripId);
    this.getTripDetails();
    this.getDeviceTripStatus();
    if (this.data.data.zone == null) {
      this.data.data.zone = 'NA';
    }
    if (this.dialogData.params.modifyshow) {
      this.modifyshow = false;
    }
    this.initMap();
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  initMap() {
    const clientCode = localStorage.getItem('clientCode');
    const start = () => this.initMapByClientFlag();
    if (!clientCode) {
      start();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        start();
      },
      () => start()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.isOsm) {
        this.loadOsmap();
        this.showTripOnOSMap();
        if (this.liveData) {
          this.plotVehicle();
        }
      } else {
        this.cd.detectChanges();
        this.loadgmap(() => {
          this.showTripOnMap();
          if (this.liveData) {
            this.plotVehicle();
          }
        });
      }
    }, 0);
  }

  loadOsmap() {
    this.map = L.map("map", {
      fullscreenControl: true,
      dragging: true
    }).setView(
      [
        this.dialogData.data.site.landmark.latitude,
        this.dialogData.data.site.landmark.longitude
      ],
      13
    );
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
  }

  loadgmap(afterInit?: () => void) {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    const mapEl = document.getElementById('map');
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    this.initGoogleMapAsync(mapEl, afterInit);
  }

  private scheduleGoogleMapLoadRetry(afterInit?: () => void): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      afterInit?.();
      return;
    }
    setTimeout(() => this.loadgmap(afterInit), 100);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement, afterInit?: () => void): Promise<void> {
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    try {
      const mapCenter = {
        lat: this.dialogData.data.site.landmark.latitude,
        lng: this.dialogData.data.site.landmark.longitude
      };
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry(afterInit);
        return;
      }
      this.map = new MapClass(mapEl, {
        center: mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      this.googleMapInitialized = true;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(mapCenter);
        afterInit?.();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry(afterInit);
    }
  }

  private getGoogleEmployeeIcon(iconUrl: string): any {
    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(36, 42),
      anchor: new google.maps.Point(18, 42),
      labelOrigin: new google.maps.Point(18, -6)
    };
  }

  showTripOnOSMap() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getOSMRoute + this.dialogData.data.tripId,
      success => {
        let wps = [];
        if (success.body.OSRM) {
          success.body.OSRM.waypoints.forEach((wp, i) => {
            this.ltlngs.push([wp.location[1], wp.location[0]]);
            wps.push(L.latLng(wp.location[1], wp.location[0]));
          });
          let r = L.Routing.control({
            serviceUrl: AppConstants.OSM_ROUTING_URL,
            showAlternatives: false,
            lineOptions: {
              styles: [{
                color: "#000",
                weight: 3,
                opacity: 0.7
              }]
            },
            fitSelectedRoutes: true,
            waypointMode: "connect",
            addWaypoints: false,
            draggableWaypoints: false,
            autoRoute: true,
            reverseWaypoints: false,
            altLineOptions: {
              styles: [{
                color: "#ed6852",
                weight: 3
              }]
            },
            show: true,
            routeWhileDragging: false,
            createMarker: (i, wp, nWps) => {
              if (success.body.LOGTYPE === "IN") {
                if (i === this.dialogData.data.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: "./assets/images/company.png",
                      iconSize: [40, 40]
                    })
                  }).bindPopup(this.dialogData.data.site.landmark.landmark);
                  return m;
                }
              } else {
                if (i === 0) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: "./assets/images/company.png",
                      iconSize: [40, 40]
                    })
                  }).bindPopup(this.dialogData.data.site.landmark.landmark);
                  return m;
                }
              }
              if (success.body.LOGTYPE === "IN") {
                if (i < this.dialogData.data.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl:
                        this.dialogData.data.tripUsers[i].tripUser
                          .userInfoDetails.gender === "Female"
                          ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                      iconSize: [65, 70]
                    })
                  })
                    .bindPopup('<tr><td>UserName : </td<td>' + this.dialogData.data.tripUsers[i].tripUser
                      .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                      this.dialogData.data.tripUsers[i].landmark.area.area + ', ' +
                      this.dialogData.data.tripUsers[i].landmark.landmark + '</td></tr>')
                    .bindTooltip(i + 1 + "", {
                      permanent: true,
                      direction: "left",
                      offset: L.point(-10, 0)
                    })
                    .openTooltip();
                  return m;
                }
              } else {
                if (i - 1 <= this.dialogData.data.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl:
                        this.dialogData.data.tripUsers[i - 1].tripUser
                          .userInfoDetails.gender === "Female"
                          ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                      iconSize: [65, 70]
                    })
                  })
                    .bindPopup('<tr><td>UserName : </td<td>' + this.dialogData.data.tripUsers[i - 1].tripUser
                      .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                      this.dialogData.data.tripUsers[i - 1].landmark.area.area + ', ' +
                      this.dialogData.data.tripUsers[i - 1].landmark.landmark + '</td></tr>')
                    .bindTooltip(i + "", {
                      permanent: true,
                      direction: "left",
                      offset: L.point(-10, 0)
                    })
                    .openTooltip();
                  return m;
                }
              }
            }
          }).addTo(this.map);
          r.setWaypoints(wps);
          r.hide();
        } else {
          this.notifyService.showInfo("OSRM data error.", null);
        }
      }, () => { });
  }

  getDeviceTripStatus() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getDeviceTripStatus + '?tripId=' + this.data.data.tripId,
      success => {
        if (success != null) {
          this.tripStatus = success.body.deviceTripStatus;
        } else {
          this.tripStatus = null;
        }
      }, () => { });
  }

  GetSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  }

  showTripOnMap() {
    if (!this.map) {
      return;
    }
    const siteCoords = this.dialogData.data.site.landmark;
    const siteLatlng = { lat: siteCoords.latitude, lng: siteCoords.longitude };
    new google.maps.Marker({
      position: new google.maps.LatLng(siteLatlng.lat, siteLatlng.lng),
      icon: { url: "./assets/images/company.png", scaledSize: new google.maps.Size(40, 40) },
      map: this.map,
      title: this.dialogData.data.site.siteName
    });

    const waypts = this.dialogData.data.tripUsers.map(user => {
      const iconUrl = user.tripUser.userInfoDetails.gender === "Female"
        ? "./assets/images/livetracking/femaleloc.svg"
        : "./assets/images/livetracking/maleloc.svg";
      new google.maps.Marker({
        position: { lat: user.landmark.latitude, lng: user.landmark.longitude },
        icon: this.getGoogleEmployeeIcon(iconUrl),
        map: this.map,
        title: `${user.tripUser.userInfoDetails.displayName} - ${user.routedOrder}`,
        label: { text: `${user.routedOrder}`, color: "#000", fontWeight: "bold", fontSize: "12px" }
      });
      return { location: { lat: user.landmark.latitude, lng: user.landmark.longitude }, stopover: true };
    });

    const isInTrip = this.dialogData.data.shift.logType === "IN";
    const firstUser = this.dialogData.data.tripUsers[0];
    const lastUser = this.dialogData.data.tripUsers[this.dialogData.data.tripUsers.length - 1];
    const startPoint = isInTrip
      ? { lat: firstUser.landmark.latitude, lng: firstUser.landmark.longitude }
      : siteLatlng;
    const endPoint = isInTrip
      ? siteLatlng
      : { lat: lastUser.landmark.latitude, lng: lastUser.landmark.longitude };
    // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
    const middleWaypts = (isInTrip ? waypts.slice(1) : waypts.slice(0, -1)).map(wp => ({
      lat: wp.location.lat,
      lng: wp.location.lng
    }));
    this.drawShortestGoogleRoute(startPoint, endPoint, middleWaypts);
  }

  /** Shortest driving path — same strategy as BE Routes API computeRoutes. */
  private async drawShortestGoogleRoute(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[] = []
  ): Promise<void> {
    try {
      const drawn = await this.drawShortestRouteViaMapsJs(origin, destination, middlePoints)
        || await this.drawShortestRouteViaRestApi(origin, destination, middlePoints);
      if (drawn) {
        return;
      }
    } catch (error) {
      console.warn('Shortest Routes API path failed; falling back to Directions alternatives', error);
    }
    this.drawShortestRouteViaDirectionsService(origin, destination, middlePoints);
  }

  private async drawShortestRouteViaMapsJs(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    if (!google.maps?.importLibrary) {
      return false;
    }
    const routesLib = await google.maps.importLibrary('routes') as any;
    const RouteClass = routesLib?.Route;
    if (!RouteClass?.computeRoutes) {
      return false;
    }
    const request: any = {
      origin,
      destination,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      fields: ['path', 'distanceMeters', 'polyline']
    };
    if (middlePoints.length) {
      request.intermediates = middlePoints.map(point => ({ location: point }));
    }
    const { routes } = await RouteClass.computeRoutes(request);
    const shortest = this.pickShortestRouteByDistanceMeters(routes);
    if (!shortest) {
      return false;
    }
    let path = shortest.path;
    if (!path?.length && shortest.polyline?.encodedPolyline) {
      path = this.decodeGoogleEncodedPolyline(shortest.polyline.encodedPolyline);
    }
    if (!path?.length) {
      return false;
    }
    this.renderGoogleRoutePath(path);
    return true;
  }

  private async drawShortestRouteViaRestApi(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    const apiKey = this.getGoogleMapsApiKey();
    if (!apiKey) {
      return false;
    }
    const body: any = {
      origin: { location: { latLng: { latitude: origin.lat, longitude: origin.lng } } },
      destination: { location: { latLng: { latitude: destination.lat, longitude: destination.lng } } },
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      languageCode: 'en-US',
      units: 'METRIC'
    };
    if (middlePoints.length) {
      body.intermediates = middlePoints.map(point => ({
        location: { latLng: { latitude: point.lat, longitude: point.lng } }
      }));
    }
    const response = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'routes.distanceMeters,routes.polyline.encodedPolyline'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      console.warn('Routes REST API failed', response.status, await response.text());
      return false;
    }
    const payload = await response.json();
    const shortest = this.pickShortestRouteByDistanceMeters(payload?.routes);
    const encoded = shortest?.polyline?.encodedPolyline;
    if (!encoded) {
      return false;
    }
    this.renderGoogleRoutePath(this.decodeGoogleEncodedPolyline(encoded));
    return true;
  }

  private drawShortestRouteViaDirectionsService(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): void {
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      suppressPolylines: true
    });
    directionsDisplay.setMap(this.map);
    directionsService.route({
      origin,
      destination,
      waypoints: middlePoints.map(point => ({ location: point, stopover: true })),
      optimizeWaypoints: false,
      avoidHighways: false,
      avoidTolls: false,
      provideRouteAlternatives: middlePoints.length === 0,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, (response, status) => {
      if (status !== google.maps.DirectionsStatus.OK || !response?.routes?.length) {
        return;
      }
      const shortestRoute = response.routes.reduce((shortest, route) => {
        const shortestDist = this.getDirectionsRouteDistanceMeters(shortest);
        const routeDist = this.getDirectionsRouteDistanceMeters(route);
        return routeDist < shortestDist ? route : shortest;
      }, response.routes[0]);
      response.routes = [shortestRoute];
      directionsDisplay.setDirections(response);
      this.renderGoogleRoutePath(shortestRoute.overview_path);
    });
  }

  private pickShortestRouteByDistanceMeters(routes: any[] | undefined): any | null {
    if (!routes?.length) {
      return null;
    }
    return routes.reduce((shortest, route) => {
      const shortestDist = shortest?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      const routeDist = route?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      return routeDist < shortestDist ? route : shortest;
    }, routes[0]);
  }

  private getDirectionsRouteDistanceMeters(route: any): number {
    return (route?.legs || []).reduce((sum, leg) => sum + (leg?.distance?.value || 0), 0);
  }

  private renderGoogleRoutePath(path: any[]): void {
    if (!path?.length || !this.map) {
      return;
    }
    if (this.routePolyline) {
      this.routePolyline.setMap(null);
    }
    this.routePolyline = new google.maps.Polyline({
      path,
      strokeColor: '#000',
      strokeWeight: 3,
      strokeOpacity: 0.7,
      map: this.map
    });
  }

  private getGoogleMapsApiKey(): string | null {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const mapsScript = scripts.find(script => script.src?.includes('maps.googleapis.com/maps/api/js'));
    if (!mapsScript?.src) {
      return null;
    }
    try {
      return new URL(mapsScript.src).searchParams.get('key');
    } catch {
      return null;
    }
  }

  private decodeGoogleEncodedPolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates: { lat: number; lng: number }[] = [];
    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);

      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return coordinates;
  }

  modify() {
  }

  getTripDetails() {
    const token = this.serviceLocalStorage.getAuthToken();
    this._mCurrentUser = this.serviceLocalStorage.getUserObject();
    let body = {
      tripIdList: this.tripsList,
      clientCode: this._mCurrentUser.clientCode,
      token: token
    };

    this.apiService.doPostRequestWithResponseForLiveTracking(ApiConstants.fetchgeoposition, body, (success) => {
      this.liveData = success.body;
      if (this.map) {
        this.plotVehicle();
        this.setOSMLiveLocation();
      }
    }, () => { });
  }

  setOSMLiveLocation() {
    if (this.showGoogleMap) {
      this.setGoogleLiveLocation();
      return;
    }
    if (this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.markers.forEach(m => {
          if (m.customData.tripId === vehicle.tripId) {
            if (vehicle.status == 'DANGER') {
              m._icon.src = "./assets/images/livetracking/vehicle/FF503F.png"
            } else {
              m._icon.src = "./assets/images/livetracking/vehicle/" +
                vehicle.vehicleColorCode.replace(/#/g, "") +
                ".png#"
            }
            const elevationAngle = vehicle.elevation
              ? parseInt(vehicle.elevation)
              : 0;
            var newLatLng = new L.LatLng(vehicle.latitude, vehicle.longitude);
            m.setRotationAngle(elevationAngle);
            m.slideTo(newLatLng, {
              duration: 1000,
              keepAtCenter: false
            });
          }
        });
      });
    } else {
      if (this.markers.length > 0) {
        this.markers.forEach(m => {
          this.map.removeLayer(m);
        });
      }
    }
  }

  private setGoogleLiveLocation(): void {
    if (!this.map || !this.liveData) {
      return;
    }
    if (this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.markers.forEach(m => {
          if (m.customData?.tripId === vehicle.tripId) {
            const iconUrl = vehicle.status === 'DANGER'
              ? "./assets/images/livetracking/vehicle/FF503F.png"
              : "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#";
            m.setIcon({
              url: iconUrl,
              scaledSize: new google.maps.Size(45, 40),
              anchor: new google.maps.Point(15, 20)
            });
            m.setPosition({ lat: vehicle.latitude, lng: vehicle.longitude });
          }
        });
      });
    } else if (this.markers.length > 0) {
      this.markers.forEach(m => m.setMap(null));
      this.markers = [];
    }
  }

  plotVehicle() {
    if (!this.map) {
      return;
    }
    if (this.showGoogleMap) {
      this.markers.forEach(marker => marker.setMap(null));
    } else {
      this.markers.forEach(marker => {
        if (this.map?.hasLayer?.(marker)) {
          this.map.removeLayer(marker);
        }
      });
    }
    this.markers = [];
    if (this.liveData && this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.showSingleRunningTrip(vehicle);
      });
    }
  }

  showSingleRunningTrip(vehicle) {
    let reqData = { tripId: vehicle.tripId };
    this.apiService.doPostRequestWithResponseForLiveTracking(ApiConstants.showSingleRunningTrip, reqData, (success) => {
      if (success.status == 200) {
        this.tripListData = success.body;
        if (this.tripListData[0] != null) {
          let tripcodes = this.tripListData[0];
          let tripcode = tripcodes.tripDetails.tripCode;
          let tripCodeLength = tripcode.length;
          this.routeId = tripcode.slice(tripCodeLength - 3, tripCodeLength)
          if (vehicle.vehicleStatus !== "stopped") {
            this.addOSMarker(vehicle);
          }
        }
      }
    }, () => { });
  }

  addOSMarker(vehicle) {
    if (!this.map) {
      return;
    }
    if (this.showGoogleMap) {
      this.addGoogleVehicleMarker(vehicle);
      return;
    }
    this.map.panTo(new L.LatLng(vehicle.latitude, vehicle.longitude));
    let carMarker = new L.Icon({
      iconUrl:
        "./assets/images/livetracking/vehicle/" +
        vehicle.vehicleColorCode.replace(/#/g, "") +
        ".png#",
      iconSize: [45, 40],
      iconAnchor: [15, 20]
    });
    let marker = new L.marker([vehicle.latitude, vehicle.longitude], {
      icon: carMarker
    })
      .addTo(this.map)
      .bindPopup(
        $('<b style="cursor:pointer">' + vehicle.vehicleNo + " " + this.routeId + "</b>").click(
          () => { }
        )[0]
      );
    marker.customData = vehicle;
    this.markers.push(marker);
  }

  private addGoogleVehicleMarker(vehicle: any): void {
    const iconUrl = "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#";
    const marker = new google.maps.Marker({
      position: { lat: vehicle.latitude, lng: vehicle.longitude },
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(45, 40),
        anchor: new google.maps.Point(15, 20)
      },
      map: this.map,
      title: `${vehicle.vehicleNo} ${this.routeId || ''}`.trim()
    });
    marker.customData = vehicle;
    this.map.panTo({ lat: vehicle.latitude, lng: vehicle.longitude });
    this.markers.push(marker);
  }

  performTripAction(action: string): void {
    const allowedRoles = ['Admin', 'Super Admin', 'Site Admin', 'Vendor'];

    if (!allowedRoles.includes(this.roleName)) {
      this.notifyService.showWarning("You don't have permission", null);
      return;
    }

    this.apiService.doPostRequestWithResponse(
      `${ApiConstants.tripAction}${this.data.data.tripId}&action=${action}`,
      '',
      success => {
        if (success.status === 200) {
          const message = success?.body?.message ?? 'Error in updating';
          this.notifyService[message === 'Updated successfully' ? 'showSuccess' : 'showWarning'](message, null);
        }
      },
      error => {
        console.error(error);
        this.notifyService.showError('Error in updating', null);
      }
    );
  }
}
